// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { StatusChip } from '@/components/status-chip';
import {
  FULFILLMENT_BY_SKU_REPORT_STATUS_LABELS,
  FulfillmentBySkuReportStatus,
} from '@/report/api/types';
import { FulfillmentBySkuReportStatusIcon } from '@/report/components/fulfillment-by-sku-report-status-icon';
import { Box, ChipProps } from '@mui/material';

type ChipVariant = ChipProps['variant'] | 'text';

interface ChipConfig {
  color: ChipProps['color'];
  variant: ChipVariant;
}

const STATUS_CHIP_CONFIG: Record<FulfillmentBySkuReportStatus, ChipConfig> = {
  OPEN: { color: 'default', variant: 'filled' },
  PARTIALLY_FULFILLED: { color: 'default', variant: 'outlined' },
  FULLY_FULFILLED: { color: 'primary', variant: 'filled' },
  OVERAGE: { color: 'error', variant: 'outlined' },
};

const CHIP_ICON_SIZE_PX = 16;

interface Props {
  status: FulfillmentBySkuReportStatus;
}

export function FulfillmentBySkuReportStatusChip(props: Props) {
  const config = STATUS_CHIP_CONFIG[props.status];

  return (
    <StatusChip
      icon={
        <Box
          component="span"
          sx={{
            alignItems: 'center',
            display: 'inline-flex',
            height: CHIP_ICON_SIZE_PX,
            justifyContent: 'center',
            ml: 0.75,
            mr: -0.25,
            width: CHIP_ICON_SIZE_PX,
            '& .MuiSvgIcon-root': {
              fontSize: CHIP_ICON_SIZE_PX,
            },
          }}
        >
          <FulfillmentBySkuReportStatusIcon
            status={props.status}
            fontSize="small"
          />
        </Box>
      }
      label={FULFILLMENT_BY_SKU_REPORT_STATUS_LABELS[props.status]}
      color={config.color}
      variant={config.variant}
    />
  );
}
